export let ADDON_OPTIONS = [
  { value: 'Yes', title: t('Yes') },
  { value: 'No', title: t('No') },
  { value: 'Partial', title: t('Yes, but only on...') },
];
